
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 0a10 10 0 100 20 10 10 0 000-20zm0 18.75a8.75 8.75 0 01-8.084-5.402A8.75 8.75 0 1110 18.75z","fill":"#fff"}}),_c('path',{attrs:{"d":"M16.25 6.313a.625.625 0 00-.881 0L8.43 13.219l-3.75-3.75a.635.635 0 10-.93.863L8.43 15l7.82-7.8a.624.624 0 00.184-.444.626.626 0 00-.185-.443z","fill":"#fff"}})])
          )
        }
      }
    